import { isDefinedString } from "et3-type-guards";
import React from "react";
import getCorePersonalStore from "../../../../stores/core/core-personal-store";
import Et3Button from "../../../../core/et3-button";
import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";
import PasswordInput from "./PasswordInput";
import Et3Margin from "../../../../core/et3-ui/ET3Margin";

const PasswordForm = withLiteObserverAndTheme(() => {
  return (
    <React.Fragment>
      <PasswordInput />
      <Et3Margin top={30} bottom={0} left={0} right={0} />
      <Et3Button
        onClick={() => getCorePersonalStore().changePasswordHandler()}
        isEnabled={
          isDefinedString(getCorePersonalStore().oldPassword.get()) &&
          isDefinedString(getCorePersonalStore().newPassword.get()) &&
          isDefinedString(getCorePersonalStore().confirmPassword.get())
        }
        size="LARGE"
        type="GET"
        text="CHANGE_PASSWORD"
      />
    </React.Fragment>
  );
});
export default PasswordForm;
